import { render, staticRenderFns } from "./RequisitionDialog.vue?vue&type=template&id=dda688ce"
import script from "./RequisitionDialog.vue?vue&type=script&lang=js"
export * from "./RequisitionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports